import Vue from 'vue';

import {
  CollapsePlugin,
  FormSelectPlugin,
  PaginationPlugin,
  SpinnerPlugin,
  TablePlugin
} from 'bootstrap-vue';

Vue.use(TablePlugin);
Vue.use(SpinnerPlugin);
Vue.use(PaginationPlugin);
Vue.use(FormSelectPlugin);
Vue.use(CollapsePlugin);
